<template>
  <div id="parkingLockMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>车位锁管理</el-breadcrumb-item>
          <el-breadcrumb-item>车位锁列表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::">
              <el-select v-model="selCustID"
                         filterable
                         clearable
                         placeholder="请选择客户"
                         @change="setPark($event,0)">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库名称::">
              <el-select v-model="selfParkID"
                         filterable
                         clearable
                         placeholder="请选择场库">
                <el-option v-for="item in choiceParks"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字::">
              <el-input placeholder="请输入车位编号/车位锁编号"
                        v-model="searchKeyWord">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="bindQuery">查询</el-button>
              <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  class="searchRowAdd">
            <el-button type="primary"
                       size="small"
                       @click="addSyncChannel">新增车位锁</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="chnlList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                          width="50"
                          :index="indexMethod"
                          label="序号">
        </el-table-column>
        <el-table-column prop="fOpLastTime"
                          width="150"
                          label="最后同步时间">
        </el-table-column>
        <el-table-column prop="fCustNo"
                          width="90px"
                          label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                          width="105"
                          label="客户名称">
        </el-table-column>
        <el-table-column prop="fParkNo"
                          width="90px"
                          label="场库编号">
        </el-table-column>
        <el-table-column prop="fParkName"
                          width="115px"
                          label="场库名称">
        </el-table-column>
        <el-table-column prop="fFloorName"
                          width="90px"
                          label="楼层名称">
        </el-table-column>
        <el-table-column prop="fAreaName"
                          width="90px"
                          label="区域名称">
        </el-table-column>
        <el-table-column prop="fPlaceNo"
                          width="90px"
                          label="车位编号">
        </el-table-column>
        <el-table-column prop="fLockType"
                          width="100px"
                          label="车位锁类型">
        </el-table-column>
        <el-table-column prop="fLockNum"
                          width="135px"
                          label="车位锁编号">
        </el-table-column>
        <el-table-column prop="fLockStatus"
                          width="90px"
                          label="车位锁状态">
        </el-table-column>
        <el-table-column prop="fParkingState"
                          width="90px"
                          label="车辆状态">
        </el-table-column>
        <el-table-column prop="fBatQty"
                          width="90px"
                          align="right"
                          label="车位锁电量">
        </el-table-column>
        <el-table-column prop="fProbeHeight"
                          width="145px"
                          align="right"
                          label="超声波探头高度(cm)">
        </el-table-column>
        <!--<el-table-column prop="fLockGateIP"
                          width="90px"
                          label="车位锁网关">
        </el-table-column>-->
        <el-table-column prop="fLockOpTime"
                          width="150"
                          label="车位锁最后操作时间">
        </el-table-column>
        <!--<el-table-column prop="fLockAppID"
                          label="AppID">
        </el-table-column>
        <el-table-column prop="fLockAppSecret"
                          label="AppSecret">
        </el-table-column>-->
        <el-table-column fixed="right"
                          label="操作"
                          align="center"
                          width="315">
          <template slot-scope="scope">
            <el-button @click="viewChannel(scope.row)"
                        type="success"
                        size="mini">查看</el-button>
            <el-button size="mini"
                        type="warning"
                        v-if="is_edit"
                        @click="editChannel(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini"
                        type="danger"
                        v-if="is_del"
                        @click="deleteChnlClient(scope.$index, scope.row)">删除</el-button>
            <el-popover placement="top">
                <div style="padding-left:10px;padding-right:10px">
                      <el-button size="mini"
                             type="warning"
                             v-if="is_ascParkLock"
                             @click="ascParkLockButton(scope.$index, scope.row)">升锁</el-button>
                      <el-button size="mini"
                             type="warning"
                             v-if="is_descParkLock"
                             @click="descParkLockButton(scope.$index, scope.row)">降锁</el-button>
                      <el-button size="mini"
                             type="warning"
                             v-if="is_descOrAecParkLock"
                             @click="descOrAecParkLockButton(scope.$index, scope.row)">降锁且自动升起</el-button>
                      <el-button size="mini"
                            type="warning"
                            v-if="is_getParkLockStatus"
                            @click="getParkLockStatusButton(scope.$index, scope.row)">获取锁状态</el-button>
                      <el-button size="mini"
                            type="success"
                            v-if="is_getParkLockStatus"
                            @click="getConfigButton(scope.$index, scope.row)">查看回调配置信息</el-button>
                      <el-button size="mini"
                            type="warning"
                            v-if="is_getParkLockStatus"
                            @click="configButton(scope.$index, scope.row)">回调地址配置</el-button>
                    </div>
                    <el-button slot="reference"
                               size="mini">更多操作</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="myChnlEditOrDetail">
      <el-dialog :title="detailTitle"
                 v-dialogDrag
                 :visible.sync="chnlEditOrDetailVisible"
                 class="channelDialog"
                 top="20vh"
                 left="0vh"
                 width="50%">
        <el-form :model="curRowInfo"
                       :rules="groupRules"
                       ref="parkLockForm"
                       label-width="115px">
          <el-row style="padding-top:10px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="客户名称::" prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                        filterable
                        placeholder="请选择客户"
                        :disabled="!curRowInfo.isEdit || !curRowInfo.edit"
                        class="myChnlInput"
                        style="width: 100%"
                        @change="setPark($event,1)">
                  <el-option v-for="item in choiceCusts"
                            :key="item.fCustID"
                            :label="item.unionName"
                            :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="场库名称::" prop="fParkID">
                <el-select v-model="curRowInfo.fParkID"
                        filterable
                        placeholder="请选择场库"
                        :disabled="!curRowInfo.isEdit || !curRowInfo.edit"
                        class="myChnlInput"
                        style="width: 100%">
                  <el-option v-for="item in parks"
                            :key="item.fParkID"
                            :label="item.fParkName"
                            :value="item.fParkID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="楼层名称::"
                            prop="fFloorName">
                <el-input v-model="curRowInfo.fFloorName"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="区域名称::"
                            prop="fAreaName">
                <el-input v-model="curRowInfo.fAreaName"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车位编号::"
                            prop="fPlaceNo">
                <el-input v-model="curRowInfo.fPlaceNo"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车位锁编号::"
                            prop="fLockNum">
                <el-input v-model="curRowInfo.fLockNum"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="车位锁类型::">
                <el-input v-model="curRowInfo.fLockType"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="车位锁网关::"
                            prop="fLockGateIP">
                <el-input v-model="curRowInfo.fLockGateIP"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="AppID::"
                            prop="fLockAppID">
                <el-input v-model="curRowInfo.fLockAppID"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="8">
              <el-form-item label="AppSecret::"
                            prop="fLockAppSecret">
                <el-input v-model="curRowInfo.fLockAppSecret"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经度::">
                <el-input v-model="curRowInfo.fLongitude"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="纬度::">
                <el-input v-model="curRowInfo.fLatitude"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="16">
              <el-form-item label="三方推送地址::">
                <el-input v-model="curRowInfo.fThiPubUrl"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="三方token::">
                <el-input v-model="curRowInfo.fThiToken"
                          style="width:100%"
                          placeholder="http头部token，没有为空"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('parkLockForm')"
                     v-if="curRowInfo.isEdit"
                     :loading="save_loading">{{save_msg}}</el-button>
          <el-button @click="chnlEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="viewConfigDetailTitle"
                 v-dialogDrag
                 :visible.sync="viewConfigDetailVisible"
                 class="channelDialog"
                 top="20vh"
                 left="0vh"
                 width="20%">
        <el-form :model="curRowConfigInfo"
                       :rules="groupConfigRules"
                       ref="parkLockConfigForm"
                       label-width="155px">
          <el-row style="padding-top:10px;padding-left:10px;padding-right:10px">
            <el-col :span="12">
              <el-form-item label="APPID::">
                <el-input v-model="curRowConfigInfo.fLockAppID"
                          style="width:100%"
                          :disabled="!curRowConfigInfo.isEdit"></el-input>
                <el-input v-model="curRowConfigInfo.fDdLockID"
                          style="width:100%"
                          v-if="false"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-top:10px;padding-left:10px;padding-right:10px">
            <el-col :span="12">
              <el-form-item label="主动升降通知地址::">
                <el-input v-model="curRowConfigInfo.fNotifyUrl"
                          style="width:100%"
                          :disabled="!curRowConfigInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="非主动升降通知地址::">
                <el-input v-model="curRowConfigInfo.fNotifyUrl2"
                          style="width:100%"
                          :disabled="!curRowConfigInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitConfigForm('parkLockConfigForm')"
                     v-if="curRowConfigInfo.isEdit"
                     :loading="save_loading">{{save_msg}}</el-button>
          <el-button @click="viewConfigDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'parkingLockMain.vue',
  data () {
    return {
      loading: false,
      is_ascParkLock: false,
      is_descParkLock: false,
      is_descOrAecParkLock: false,
      is_getParkLockStatus: false,
      is_edit: false,
      is_del: false,
      is_syn: false,
      is_export: false,
      export_msg: '导出',
      export_loading: false,
      save_msg: '保存',
      save_loading: false,
      selCustID: '',
      choiceCusts: [],
      curRowInfo: {
        fDdLockID: 0,
        edit: false,
        isEdit: false,
        fCustID: '',
        fCustNo: '',
        fCustName: '',
        fParkID: '',
        fParkNo: '',
        fParkName: '',
        fFloorName: '',
        fAreaName: '',
        fPlaceNo: '',
        fLockType: '',
        fLockNum: '',
        fLockGateIP: '',
        fLockAppID: '',
        fLockAppSecret: '',
        fThiPubUrl: '',
        fThiToken: '',
        fLongitude: '',
        fLatitude: ''
      },
      curRowConfigInfo: {
        fDdLockID: 0,
        isEdit: false,
        fNotifyUrl: '',
        fLockAppID: '',
        fNotifyUrl2: ''
      },
      groupConfigRules: {
        fNotifyUrl: [
          { required: true, message: '主动升降通知地址不能为空', trigger: 'change' }
        ],
        fNotifyUrl2: [
          { required: true, message: '非主动升降通知地址不能为空', trigger: 'change' }
        ]
      },
      groupRules: {
        fCustID: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        fParkID: [
          { required: true, message: '请选择场库', trigger: 'change' }
        ],
        fFloorName: [
          { required: true, message: '请输入楼层名称', trigger: 'change' }
        ],
        fAreaName: [
          { required: true, message: '请输入区域名称', trigger: 'change' }
        ],
        fPlaceNo: [
          { required: true, message: '请输入车位编号', trigger: 'change' }
        ],
        fLockNum: [
          { required: true, message: '请输入车位锁编号', trigger: 'change' }
        ],
        fLockGateIP: [
          { required: true, message: '请输入车位锁网关', trigger: 'change' }
        ],
        fLockAppID: [
          { required: true, message: '请输入AppID', trigger: 'change' }
        ],
        fLockAppSecret: [
          { required: true, message: '请输入AppSecret', trigger: 'change' }
        ]
      },
      chnlEditOrDetailVisible: false,
      detailTitle: '查看通道信息',
      viewConfigDetailVisible: false,
      viewConfigDetailTitle: '查看车位锁配置信息',
      choiceParks: [],
      parks: [],
      selfParkID: '',
      searchKeyWord: '',
      chnlList: [],
      tableHeight: 200,
      form: {

      },
      pageSize: 20,
      pageNo: 1,
      total: 0
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    ...mapActions([
      'getParkList', 'getParkLockConfiguration', 'getParkingLockQuery', 'getChannelParamById', 'getCustByGroup', 'saveParkLock', 'saveParkLockNotifyConfig', 'deleteParkLock', 'ascParkLock', 'descParkLock', 'descOrAecParkLock', 'getParkLockStatus', 'synChnlById', 'getCurrentUserPers'
    ]),
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          this.saveParkLock(this.curRowInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.chnlEditOrDetailVisible = false
                this.initData()
                this.$message.success(data.Msg)
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    submitConfigForm (formName) {
      this.$refs[formName].validate((valid) => {
        if ((this.curRowConfigInfo.fNotifyUrl || '').trim().length <= 0) {
          this.$message.error('提示：主动升降通知地址不能为空')
          return false
        }
        if ((this.curRowConfigInfo.fNotifyUrl2 || '').trim().length <= 0) {
          this.$message.error('提示：非主动升降通知地址不能为空')
          return false
        }
        if (valid) {
          this.save_loading = true
          this.save_msg = '保存中…'
          this.saveParkLockNotifyConfig(this.curRowConfigInfo).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.viewConfigDetailVisible = false
                this.initData()
                this.$message.success(data.Msg)
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    addSyncChannel () {
      this.parks = []
      setTimeout(() => {
        if (this.$refs['parkLockForm']) {
          this.$refs['parkLockForm'].clearValidate()
        }
      }, 50)
      this.detailTitle = '新增车位锁'
      this.chnlEditOrDetailVisible = true
      this.curRowInfo = {
        fDdLockID: 0,
        edit: true,
        isEdit: true,
        fCustID: '',
        fCustNo: '',
        fCustName: '',
        fParkID: '',
        fParkNo: '',
        fParkName: '',
        fFloorName: '',
        fAreaName: '',
        fPlaceNo: '',
        fLockType: 'DD-LOCK',
        fLockNum: '',
        fLockGateIP: 'https://api.dwith.cn',
        fLockAppID: '5643A1188',
        fLockAppSecret: '793e81f38eb94adba71d226a52089bff',
        fThiPubUrl: '',
        fThiToken: '',
        fLongitude: '',
        fLatitude: ''
      }
    },
    exportData () {
      // if ((this.selCustID || '').trim().length <= 0) {
      //   this.$message.error('提示：请先选择客户')
      //   return false
      // }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      let chnlParam = {}
      chnlParam['fParkID'] = this.selfParkID
      chnlParam['fCustID'] = this.selCustID
      chnlParam['searchKeyWord'] = this.searchKeyWord
      chnlParam.pageSize = this.pageSize
      chnlParam.pageNo = this.pageNo
      chnlParam.exportData = 1
      this.getParkingLockQuery(chnlParam).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_场库车位锁数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    bindQuery () {
      this.initData()
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    initData () {
      let chnlParam = {}
      chnlParam['fParkID'] = this.selfParkID
      chnlParam['fCustID'] = this.selCustID
      chnlParam['searchKeyWord'] = this.searchKeyWord
      chnlParam.pageSize = this.pageSize
      chnlParam.pageNo = this.pageNo
      chnlParam.exportData = 0
      this.loading = true
      this.getParkingLockQuery(chnlParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              // let tmpChnl = []
              // Object.assign(tmpChnl, data.Data.rows)
              this.chnlList = data.Data.rows || []
              this.total = data.Data.total
            }
          }
        }
      })
    },
    editChannel (index, row) {
      setTimeout(() => {
        if (this.$refs['parkLockForm']) {
          this.$refs['parkLockForm'].clearValidate()
        }
      }, 50)
      this.getParkList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data || []
            }
          }
        }
      })
      this.detailTitle = '编辑车位锁【' + row.fLockNum + '】'
      this.chnlEditOrDetailVisible = true
      this.curRowInfo = {}
      this.curRowInfo = row
      this.curRowInfo.isEdit = true
      this.curRowInfo.edit = false
    },
    viewChannel (row) {
      setTimeout(() => {
        if (this.$refs['parkLockForm']) {
          this.$refs['parkLockForm'].clearValidate()
        }
      }, 50)
      this.getParkList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.parks = data.Data || []
            }
          }
        }
      })
      this.detailTitle = '查看车位锁【' + row.fLockNum + '】'
      this.chnlEditOrDetailVisible = true
      this.curRowInfo = {}
      this.curRowInfo = row
      this.curRowInfo.isEdit = false
      this.curRowInfo.edit = false
    },
    deleteChnlClient (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteParkLock({ fDdLockID: row.fDdLockID }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    ascParkLockButton (index, row) {
      this.$confirm('升起该车位锁, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ascParkLock({ fDdLockID: row.fDdLockID }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    descParkLockButton (index, row) {
      this.$confirm('降下该车位锁, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.descParkLock({ fDdLockID: row.fDdLockID }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    descOrAecParkLockButton (index, row) {
      this.$confirm('降下该车位锁, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.descOrAecParkLock({ fDdLockID: row.fDdLockID }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    getParkLockStatusButton (index, row) {
      this.$confirm('获取车位锁状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getParkLockStatus({ fDdLockID: row.fDdLockID }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    getConfigButton (index, row) {
      this.viewConfigDetailTitle = '查看车位锁配置信息'
      this.curRowConfigInfo = {}
      this.getParkLockConfiguration({ fDdLockID: row.fDdLockID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.curRowConfigInfo = data.Data
              this.curRowConfigInfo.isEdit = false
            }
          }
        }
      })
      this.curRowConfigInfo.isEdit = false
      this.viewConfigDetailVisible = true
    },
    configButton (index, row) {
      this.viewConfigDetailTitle = '查看车位锁配置信息'
      this.curRowConfigInfo = {}
      this.getParkLockConfiguration({ fDdLockID: row.fDdLockID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.curRowConfigInfo = data.Data
              this.curRowConfigInfo.isEdit = true
            }
          }
        }
      })
      this.curRowConfigInfo.isEdit = true
      this.viewConfigDetailVisible = true
    },
    setPark (val, type, fParkID = '') {
      if (type === 0) {
        this.choiceParks = []
        this.selfParkID = ''
      } else if (type === 1) {
        this.parks = []
        if ((fParkID || '').trim().length <= 0) {
          this.curRowInfo.fParkID = ''
        }
      }
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (type === 0) {
                this.choiceParks = data.Data || []
              } else if (type === 1) {
                this.parks = data.Data || []
              }
            }
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 26000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
            this.is_ascParkLock = data.Data.data.is_ascParkLock
            this.is_descParkLock = data.Data.data.is_descParkLock
            this.is_descOrAecParkLock = data.Data.data.is_descOrAecParkLock
            this.is_getParkLockStatus = data.Data.data.is_getParkLockStatus
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.fGrpID = this.choiceCusts[0].fGrpID
              this.setPark(this.selCustID, 0)
            }
          }
        }
      }
    })
    this.initData()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
/* #parkingLockMain .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
} */
/* .myChnlEditOrDetail .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 13px;
} */
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
.myChnlEditOrDetail
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
.myChnlEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.myChnlEditOrDetail .el-dialog__title {
  color: white;
}
.myChnlEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.myChnlEditOrDetail .el-dialog__body {
  padding: 5px;
  padding-bottom: 0px;
}
.myChnlEditOrDetail .ledDialog .el-dialog__body {
  padding: 0px;
}
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #666666;
  cursor: not-allowed;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .myChnlLableClass {
  text-align: right;
  float: left;
  color: #606266;
  line-height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .is-disabled .el-input__inner,
.myChnlEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}
.myChnlEditOrDetail .el-row {
  margin-bottom: 5px;
}
.myChnlEditOrDetail .el-radio {
  line-height: 2px;
}
/* dialog弹出框样式 */
#parkingLockMain .channelDialog .el-dialog {
  min-width: 910px;
}
#parkingLockMain .screenDialog .el-dialog {
  min-width: 800px;
}
#parkingLockMain .voiceDialog .el-dialog {
  min-width: 410px;
}
#parkingLockMain .warning-row {
  color: chocolate;
}
</style>

<style scoped>
fieldset {
  padding-bottom: 0px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/park/parkingLockMain.vue